import { useContext } from 'react'

import { ENTITY_LISTING_VIEW_TYPE } from '../../../../../../constants/common'
import { Screen } from '../../../../../../context'
import { useRequestProfileTabEmailsViewTypeContext } from '../../../RequestProfileTabEmails.hooks'
import { getIsEmailPreviewAvailable } from '../../../RequestProfileTabEmails.utils'

export function useRequestProfileTabEmailsListViewType({ isPreview }) {
  const { width: screenWidth } = useContext(Screen)

  const { listViewType, setListViewType } =
    useRequestProfileTabEmailsViewTypeContext()

  const isEmailPreviewAvailable = getIsEmailPreviewAvailable({
    isPreview,
    screenWidth,
  })

  return {
    isEmailPreviewAvailable,
    selectedListViewType: isEmailPreviewAvailable
      ? listViewType
      : ENTITY_LISTING_VIEW_TYPE.table,
    setListViewType,
  }
}
